import intersectionWith from 'lodash/intersectionWith';

export const createSelectOptionsFromSysEnums = sysEnums => sysEnums && sysEnums.map(
	enumObject => ({
		value: enumObject.id,
		label: enumObject.text
	})
);

export  const createSelectValuesUseIntersection = (first, second) => (
	intersectionWith(first, second, (firstValue, secondValue) => firstValue.value === secondValue)
);


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/form-elements/multiselect/index.js